import EditableFields from './template'

export default EditableFields;
